import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../colorVars';
import style from './OpenPctButton.module.css';

export const OpenPctButton = ({ percent, quantity, clickHandler, margin }) => {

  return (
    <button
      className={style.button}
      onClick={clickHandler}
      style={{ backgroundColor: colors.green, margin, color: colors.lightGrey }}
    >
      {`${percent}%[${quantity}]`}
    </button>
  );
};

OpenPctButton.propTypes = {
  percent: PropTypes.number,
  quantity: PropTypes.number,
  clickHandler: PropTypes.func,
  margin: PropTypes.string,
};
